import { giftHistorySchema } from "../../../lib/types/schema/subscription/giftHistorySchema";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyGiftHistory } from "./keyGiftHistory";

export const useRequestGiftHistory = () => ({
  query: useRequestQuery({
    queryFnRequestProps: {
      urlBackendPath: "/gift/history",
      schema: giftHistorySchema,
    },
    queryKey: keyGiftHistory(),
  }),
});
